import {
  ProfessionalSkills as ProfessionalSkillsT,
} from '@/types/graphql/types'
import { ActionIcon, Loader, Text, useMantineTheme } from '@mantine/core'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import { MdDeleteOutline } from 'react-icons/md'
import { Edit } from 'tabler-icons-react'
import useSkillsItem from '@/hooks/Dashoboard/Members/Profile/Skills/useSkillsItem'

const SkillsItem = ({
  ps,
  handleUpdatePs,
}: {
  ps: ProfessionalSkillsT
  handleUpdatePs: ({ newPS }: { newPS: ProfessionalSkillsT[] }) => void
}) => {
  const { colorScheme } = useMantineTheme()
  const isDark = colorScheme === 'dark'
  const { t } = useTranslation('common')

  const { openDeleteMessage, academicRank, openPSForm, loading } =
    useSkillsItem({
      ps,
      handleUpdatePs,
    })
  return (
    <div
      className={classNames(
        'border rounded-lg p-3 my-3 border-opacity-20 w-full flex',
        isDark ? 'border-gray-200' : 'border-gray-900',
      )}
    >
      <div className="flex-auto">
        <Text size="lg" weight="bold">
          {ps.placeOfWork}
        </Text>
        <Text>
          {t(ps.type ?? '')} -{' '}
          {ps.type === 'academic' ? academicRank : ps.natureOfWork}
        </Text>
        <Text size="sm" weight="lighter">
          {t('xYearsOfExperience', { x: ps.yearsOfExperience })}
        </Text>
      </div>
      <div>
        <ActionIcon variant="default" onClick={() => openPSForm(ps)} mb={5}>
          <Edit size={16} />
        </ActionIcon>
        <ActionIcon variant="default" onClick={() => openDeleteMessage(ps.id)}>
          {loading ? <Loader size="xs" /> : <MdDeleteOutline size={16} />}
        </ActionIcon>
      </div>
    </div>
  )
}

export default SkillsItem
